import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function AboutSection() {
  const { t } = useTranslation();

  const services = [
    { icon: 'ri-window-line', label: t('about.services.sprayFoam') },
    { icon: 'ri-door-line', label: t('about.services.battRoll') },
    { icon: 'ri-tools-line', label: t('about.services.atticWall') },
    { icon: 'ri-truck-line', label: t('about.services.commercial') },
  ];

  return (
    <section className="py-10 bg-background-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-14">
          {/* Image */}
          <div className="w-full lg:w-[60%] flex justify-center">
            <div className="relative w-full max-w-[640px] flex items-center justify-center">
              <img
                alt="The Screen Squad team member with screen door project"
                className="w-full h-auto max-h-[780px] object-contain rounded-2xl"
                src="https://storage.helloreaddy.io/project_files/95272ccd-89f8-41e5-a90f-f2c2b48cc48a/cc73d0fe-3b94-4530-998f-4824cee020bf_compressed_Proyecto-nuevo-9.webp"
              />
              <div className="absolute bottom-6 left-6 bg-background-200 border border-primary-500/40 text-foreground-50 px-5 py-4 rounded-xl">
                <p className="text-3xl font-extrabold text-primary-500">{t('about.badge')}</p>
                <p className="text-xs text-foreground-400 mt-0.5">{t('about.badgeLabel')}</p>
              </div>
            </div>
          </div>

          {/* Text */}
          <div className="w-full lg:w-[40%]">
            <span className="text-primary-500 text-xs font-bold uppercase tracking-[0.25em]">{t('about.label')}</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 mt-3 leading-tight">
              {t('about.title')}
            </h2>
            <p className="text-foreground-400 mt-5 text-base leading-relaxed">
              {t('about.description1')}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
              {services.map((s, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-primary-500/15 rounded-lg shrink-0">
                    <i className={`${s.icon} text-primary-500 text-base w-5 h-5 flex items-center justify-center`} />
                  </div>
                  <span className="text-foreground-400 text-sm font-medium">{s.label}</span>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold px-7 py-3.5 rounded-full text-sm transition-colors cursor-pointer mt-8"
            >
              {t('about.cta')}
              <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}